import { render } from "./ParceriasPage.vue?vue&type=template&id=5c4e7a5a"
import script from "./ParceriasPage.vue?vue&type=script&lang=js"
export * from "./ParceriasPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__